
// react-bootstrap imports
import { useEffect, useState, useRef } from "react"
import { useLocation } from "react-router-dom"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { Button, Form, OverlayTrigger} from "react-bootstrap"

// assets imports
import stdStyle from "json/StdStyles.json"
import jsonServicosTaxas from "json/ServicosTaxas.json"

// components imports
import { AlertMessage } from "components/AlertMessages"
import { BotaoVoltar, LoadingSpinner } from "components/Helpers"
import { ClassificationEdifForm } from "components/ClassificEdifFormLegado"

// service imports
import { CalcTax } from "services/CallAPIs"
import { dropdownsAreValid, getFormData, resultsAreValid } from "services/FormFunctions"
import { DynamicInputFieldsV1 } from "services/InputFieldsTaxasV1"
import { determineFormErrors, asBRL, determinaServicoEscolhidoLegado } from "services/CalcTaxaFunctions"

import { MapInputsToTaxBody } from "models/BodiesTaxa"

import * as Links from "constants/links"
import { useAlert, WarningIncompleteInputMessage, ErrorChamadaApi } from "hooks/useAlert"
import { tipoImovelIDFromNome, tipoImovelNome } from "constants/tiposImovelLegado"
import { prepareTaxInputV1 } from "services/CalcTaxaFunctionsLegado"

const InputFields = ({ taxaDados }) =>
{
    const { idServ } = taxaDados

    let fields = []

    const [areaConstMaior400, setAreaConstMaior400] = useState(false)
    const [condLotesTemComercio, setCondLotesTemComercio] = useState(false)
    const [executadaComLicenca, setExecutadaComLicenca] = useState(false)
    const [taxaOcupMenor30, setTaxaOcupMenor30] = useState(false)
    const [hasAnuencia, setHasAnuencia] = useState(false)
    const [hasAreaAverbada, setHasAreaAverbada] = useState(false)
    const [hasAreaAverbOuAprov, setHasAreaAverbOuAprov] = useState(false)
    const [areaAverbadaTemOutroUso, setAreaAverbadaTemOutroUso] = useState(false)
    const [hasAreaConst, setHasAreaConst] = useState(false)
    const [hasNumUnid, setHasNumUnid] = useState(false)
    const [houveInicioDeObra, setHouveInicioDeObra] = useState(false)
    const [possuiDemarcacao, setPossuiDemarcacao] = useState(false)
    const [tipoImovel, setTipoImovel] = useState()

    const onChangeAnuencia = () => {setHasAnuencia(!hasAnuencia)}
    const onChangeTipoImovel = () => {setTipoImovel(document.getElementsByName("tipoImovel")[0].value)}
    const onChangeTipoImovelVist = () => {
        const tipoImovelVist = document.getElementsByName("tipoImovel")[0].value
        const edifHasAreaConst = [tipoImovelNome.Uniresidencial, tipoImovelNome.NaoResidencial, tipoImovelNome.GalpaoDepositoIndustria, tipoImovelNome.ERB, tipoImovelNome.GLP].includes(tipoImovelVist)
        const edifHasNumUnid = [tipoImovelNome.MultiresidencialAte4Pav, tipoImovelNome.MultiresidencialAcima4Pav, tipoImovelNome.CondominioLotes].includes(tipoImovelVist)
        setHasAreaConst(edifHasAreaConst)
        setHasNumUnid(edifHasNumUnid)
    }
    const onChangeTaxaOcupMenor30 = () => {setTaxaOcupMenor30(document.getElementsByName("taxaOcupMenor30")[0].checked)}
    const onChangeAreaConst = () => {setAreaConstMaior400(400 < document.getElementsByName("areaConstruida")[0].value)}
    const onChangeAreaAverb = () => {setHasAreaAverbada(0 < document.getElementsByName("areaAverbada")[0].value)}
    const onChangeAreaAverbOuAprov = () => {setHasAreaAverbOuAprov(0 < document.getElementsByName("areaAverbadaOuAprovada")[0].value)}
    const onChangePossuiLicenca = () => {setExecutadaComLicenca( 0 < document.getElementsByName("areaRegularizar")[0].value )}
    const onChangeCondLotesTemComercio = () => {setCondLotesTemComercio(document.getElementsByName("temComercio")[0].checked)}
    const onChangePossuiDemarcacao = () => {setPossuiDemarcacao(document.getElementsByName("possuiDemarcacao")[0].checked)}
    const onChangeHouveInicioDeObra = () => {setHouveInicioDeObra(document.getElementsByName("houveInicioDeObra")[0].checked)}
    const onChangeTipoImovelAlvara = () => {onChangeTipoImovel() ; onChangeTipoImovelVist()}
    const onChangeAreaAverbadaTemOutroUso = () => {setAreaAverbadaTemOutroUso(document.getElementsByName("tipoImovel")[0].value !== document.getElementsByName("usoAreaAverbada")[0].value)}

    switch (idServ)
    {
        case "Alvara":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"anuencia"} OnChange={onChangeAnuencia} />)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"taxaOcupMenor30"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Uniresidencial ? <DynamicInputFieldsV1 fieldName={"conjuntoHabitacional"} /> : <></>)
            fields.push((tipoImovel !== tipoImovelNome.ERB & tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV1 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.GLP ? <DynamicInputFieldsV1 fieldName={"areaPlataforma"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV1 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.ERB ? <DynamicInputFieldsV1 fieldName={"numEstacoes"} /> : <></>)
            fields.push(<DynamicInputFieldsV1 fieldName={"houveInicioDeObra"} OnChange={onChangeHouveInicioDeObra} />)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV1 fieldName={"obraEmExecucao"} /> : <></>)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV1 fieldName={"valorPagoInicioDeObra"} OnChange={onChangeHouveInicioDeObra} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaTerreno"} /> : <></>)

            break
        }
        case "Anuencia":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push((tipoImovel !== tipoImovelNome.ERB & tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV1 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.GLP ? <DynamicInputFieldsV1 fieldName={"areaPlataforma"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV1 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.ERB ? <DynamicInputFieldsV1 fieldName={"numEstacoes"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaTerreno"} /> : <></>)

            break
        }
        case "AlvaraAcresReg":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"tipoImovelAlvaraAcresReg"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"anuencia"} OnChange={onChangeAnuencia} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"taxaOcupMenor30"} OnChange={onChangeHouveInicioDeObra} />)
            fields.push(tipoImovel === tipoImovelNome.Uniresidencial ? <DynamicInputFieldsV1 fieldName={"conjuntoHabitacional"} /> : <></>)
            fields.push(<DynamicInputFieldsV1 fieldName={"areaAcrescida"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"areaReforma"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"areaRegularizar"} OnChange={onChangePossuiLicenca} />)
            fields.push(tipoImovel === tipoImovelNome.GLP ? <DynamicInputFieldsV1 fieldName={"areaPlataforma"} /> : <></>)

            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV1 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.ERB ? <DynamicInputFieldsV1 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)

            fields.push(<DynamicInputFieldsV1 fieldName={"areaAverbada"} OnChange={onChangeAreaAverb}/>)
            fields.push(hasAreaAverbada ? <DynamicInputFieldsV1 fieldName={"usoAreaAverbada"} /> : <></>)
            fields.push(executadaComLicenca ? <DynamicInputFieldsV1 fieldName={"executadaComLicenca"} /> : <></>)
            fields.push(<DynamicInputFieldsV1 fieldName={"houveInicioDeObra"} OnChange={onChangeHouveInicioDeObra} />)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV1 fieldName={"obraEmExecucao"} /> : <></>)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV1 fieldName={"valorPagoInicioDeObra"} OnChange={onChangeHouveInicioDeObra} /> : <></>)

            break
        }
        case "AutERB": fields.push(<DynamicInputFieldsV1 fieldName={"numEstacoes"} />); break
        case "AutoDeInfracao": fields.push(<DynamicInputFieldsV1 fieldName={"diasAposVencimento"} />); break
        case "AutRepGerais": case "AutRepGeraisAcess": fields.push(<DynamicInputFieldsV1 fieldName={"houveInicioDeObra"} />); break
        case "AutObrasInfra":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"valorContrato"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"houveInicioDeObra"} />)

            break
        }
        case "CertHabitese": case "RenHabitese":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"tipoImovelHabitese"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(tipoImovel === tipoImovelNome.MultiresidencialAte4Pav ? <DynamicInputFieldsV1 fieldName={"tipoCondominio"} /> : <></>)
            fields.push(hasAreaConst ? <DynamicInputFieldsV1 fieldName={"areaConstruida"} /> : <></>)
            fields.push(hasNumUnid ? <DynamicInputFieldsV1 fieldName={"numUnid"} /> : <></>)
            //fields.push(tipoImovel === tipoImovelNome.CondominioLotes ? <DynamicInputFieldsV1 fieldName={"numLotes"} /> : <></>)
            if (tipoImovel === tipoImovelNome.CondominioLotes & document.getElementsByName("temComercio")[0] !== undefined)
            {
                fields.push(document.getElementsByName("temComercio")[0].checked ? <DynamicInputFieldsV1 fieldName={"areaConstruidaComercio"} /> : <></>)
            }

            break
        }
        case "CertRegul":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"executadaComLicenca"} />)
            fields.push(tipoImovel === tipoImovelNome.Uniresidencial ? <DynamicInputFieldsV1 fieldName={"conjuntoHabitacional"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"taxaOcupMenor30"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"atendeAsNormasUrb"} /> : <></>)
            fields.push((tipoImovel !== tipoImovelNome.ERB & tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV1 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV1 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.GLP ? <DynamicInputFieldsV1 fieldName={"areaPlataforma"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaRegularizar"} OnChange={onChangePossuiLicenca} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav | tipoImovel === tipoImovelNome.CondominioLotes | tipoImovel === tipoImovelNome.Loteamento) ? <DynamicInputFieldsV1 fieldName={"numUnid"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.MultiresidencialAte4Pav ? <DynamicInputFieldsV1 fieldName={"tipoCondominio"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaTerreno"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaAverbadaOuAprovada"} OnChange={onChangeAreaAverbOuAprov}/> : <></>)
            fields.push(hasAreaAverbOuAprov ? <DynamicInputFieldsV1 fieldName={"usoAreaAverbada"}  OnChange={onChangeAreaAverbadaTemOutroUso}/> : <></>)

            if (hasAreaAverbOuAprov & document.getElementsByName("usoAreaAverbada")[0] !== undefined)
            {
                fields.push(areaAverbadaTemOutroUso ? <DynamicInputFieldsV1 fieldName={"areaAverbadaComMudancaDeUso"} /> : <></>)
                fields.push(<DynamicInputFieldsV1 fieldName={"mudancaUsoNaoGerouReforma"} />)
            }

            break
        }
        case "CertRegulInfra":
        {            
            fields.push(<DynamicInputFieldsV1 fieldName={"valorContrato"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"houveInicioDeObra"} />)

            break
        }
        case "DeclConcInstERBSemAut":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"numEstacoes"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"atendeAsNormasUrb"} />)

            break
        }
        case "DeclGLP": fields.push(<DynamicInputFieldsV1 fieldName={"areaPlataforma"} />); break        
        case "ObraIniciadaSemLicenca":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"tiposImovelObraIniciadaSemLicenca"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"obraEmExecucao"} />)
            fields.push((tipoImovel !== tipoImovelNome.ERB & tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV1 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.GLP ? <DynamicInputFieldsV1 fieldName={"areaPlataforma"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV1 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.ERB ? <DynamicInputFieldsV1 fieldName={"numEstacoes"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaTerreno"} /> : <></>)
            fields.push(<DynamicInputFieldsV1 fieldName={"areaAcrescida"} />)

            break
        }
        case "SubsProj":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"taxaOcupMenor30"} OnChange={onChangeTaxaOcupMenor30} />)
            fields.push(!taxaOcupMenor30 ? <DynamicInputFieldsV1 fieldName={"novaTaxaOcupMaior30"} /> : <></>)
            fields.push(<DynamicInputFieldsV1 fieldName={"areaConstruidaAprovada"} OnChange={onChangeAreaConst} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"valorAlvara"} />)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaAcrescidaDeConstrucao"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV1 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.GLP ? <DynamicInputFieldsV1 fieldName={"areaAcrescidaPlataforma"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV1 fieldName={"areaTerreno"} /> : <></>)

            break
        }
        case "RenAlvara": fields.push(<DynamicInputFieldsV1 fieldName={"valorAlvara"} />); break        
        case "ReparosGeraisSemLicenca": fields.push(<DynamicInputFieldsV1 fieldName={"obraEmExecucao"} />); break   
        case "TermoDemarc":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"testada"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"incluirTaxaDemarcacao"} />)
            break
        }
        case "TermoPermUsoEspacoPublico": fields.push(<DynamicInputFieldsV1 fieldName={"numVagas"} />); break
        case "TermoDesm": case "TermoRem": case "TermoDesmRem": case "TermoDesmComIncorporacao":
        {
            fields.push(<DynamicInputFieldsV1 fieldName={"areaTerreno"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"areaRemanescente"} />)
            fields.push(<DynamicInputFieldsV1 fieldName={"possuiDemarcacao"} OnChange = {onChangePossuiDemarcacao} />)
            fields.push(possuiDemarcacao ? <DynamicInputFieldsV1 fieldName={"testada"} /> : <></>)

            break
        }
        case "TermoVerObras": fields.push(<DynamicInputFieldsV1 fieldName={"numUnid"} />); break
        default: break
    }

    fields.push(hasAnuencia ? <DynamicInputFieldsV1 fieldName={"valorAnuencia"} /> : <></>)

    if (tipoImovel === tipoImovelNome.CondominioLotes)
    {    
        fields.push(<DynamicInputFieldsV1 fieldName={"temComercio"} OnChange = {onChangeCondLotesTemComercio}/>)
        if (condLotesTemComercio)
        {
            fields.push(<ClassificationEdifForm TipoImovel={"Não residencial / misto"} fieldName="Classification form" />)
        }
        fields.push(idServ !== "SubsProj" & idServ !== "CertHabitese" & idServ !== "RenHabitese" ? <DynamicInputFieldsV1 fieldName={"areaTerreno"} /> : <></>)
    }

    if (!(idServ === "CertHabitese" | idServ === "RenHabitese") & ((tipoImovel === tipoImovelNome.Uniresidencial & areaConstMaior400) | tipoImovel === tipoImovelNome.NaoResidencial | tipoImovel === tipoImovelNome.GLP))
    {
        fields.push(<ClassificationEdifForm TipoImovel={tipoImovel} fieldName="Classification form" />)
    }
    
    fields = fields.filter((value) => {return value !== null})
    fields = fields.filter((field) => {return field.props.fieldName !== undefined})
    
    return  <div className="d-flex flex-column m-auto">{fields.map(field => <div key={field.props.fieldName}>{field}</div>)}</div>
}

const InputScreen = ({ taxaDados }) =>
{

    const Instrucoes = () =>
    {
        return (
            <>
                <small className="text-muted mb-0 fs-7">* indica campos com preenchimento obrigatório</small>
                <small className="text-muted mb-3 fs-7">obs.: use ponto (e não vírgula) para números decimais</small>
            </>
        )
    }

    return (
        <div className = "d-flex flex-column py-3">
            <p className="fw-bold text-center fs-6">{taxaDados.nome}</p>
            { !taxaDados.taxaFixa ? <Instrucoes /> : <></> }
            <InputFields taxaDados = {taxaDados} />
        </div>
    )
}

const OutputScreen = ({ results }) =>
{
    if (results === null | results === undefined) { return }

    const titleStyle = "fw-bold fs-6 text-primary"
    const contentStyle = "fs-6 text-primary"
    const totalTax = asBRL(0 < results.TaxaTotal ? results.TaxaTotal : "0")
    const detCalc = results.DetalhesDoCalculo
    const detAval = results.DetalhesDaAvaliacao
    const metCalc = results.MetodoDeCalculo

    if (results.status === 500) { return }

    return(
        <div className="d-flex flex-column mt-3 align-items-center">
            <p className={titleStyle}><u>Resultados da avaliação</u></p>

            <hr className="w-75" />
            <p className={titleStyle}><u>Taxa total</u></p>
            <p className={contentStyle}>Taxa total = {totalTax}</p>
            <hr className="w-75" />

            <p className={titleStyle}><u>Detalhes do cálculo</u></p>
            {Object.keys(detCalc).map(det => detCalc[det] !== undefined ? <p className={contentStyle} key={det}>{detCalc[det]}</p> : <></>)}

            <p className={titleStyle}><u>Detalhes da avaliação</u></p>
            {Object.keys(detAval).map(det => <p className={contentStyle} key={det}>{detAval[det]}</p>)}

            <p className={titleStyle}><u>Método de cálculo</u></p>
            {detCalc["$taxaBasica$"] === "0.0" ? null :
                Object.keys(metCalc).map(met => <p className={contentStyle} key={met}>{metCalc[met]}</p>)
            }
        </div>
    )
}

const BotoesCalcularVoltar = ({ isLoading, target }) =>
{
    // const linkVoltarEstilo = "btn btn-primary rounded-5 mx-2"
    const botaoCalcularEstilo = "rounded-5"

    return (
        <div className="d-flex justify-content-around mb-2" >
            <BotaoVoltar linkPrevPage={Links.SERVICOS_TAXAS_LEGADO} />
            <Button className={botaoCalcularEstilo} variant="success" type="submit" ref={target} disabled={isLoading}>{!isLoading ? "Calcular" : "Calculando"}</Button>                
        </div>
    )
}

const FormErrorMessage = ({ formErrors, target }) =>
{
    if (formErrors.length <= 0) { return <></> }

    return (
        <OverlayTrigger target={target.current} placement="center">
            {({ placement: _placement, arrowProps: _arrowProps, show: _show, popper: _popper, hasDoneInitialMeasure: _hasDoneInitialMeasure, ...props}) => 
            (
            <div {...props} style={{position: "absolute", backgroundColor: "rgba(255, 100, 100, 0.85)", padding: "2px 10px", color: "white", borderRadius: 3, ...props.style}}>
                {formErrors.map(error => <p key={error}>{error}</p>)}
            </div>
            )}
        </OverlayTrigger >
    )
}

export function CalcularTaxaLegadoScreen(props)
{
    const {alert, showAlert, closeAlert} = useAlert()
    const location = useLocation();
    const servico = location.state
    const taxaDados = determinaServicoEscolhidoLegado(servico, jsonServicosTaxas)
    const { idServ, taxaFixa } = taxaDados    
    
    const typeEdifList = Object.keys(tipoImovelIDFromNome)

    const [results, setResults] = useState(null)
    // const [inputData, setInputData] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false)
    /*const [showValidationMessage, setShowValidationMessage] = useState(false)
    const [showErrorMessage, setShowErrorMessage] = useState(false)*/
    const [formErrors, setFormErrors] = useState([])
    const target = useRef(null)


    const onFormSubmit = async event => {
        event.preventDefault()
        const form = event.currentTarget
        const inputData = getFormData(form)
        const formErrors = determineFormErrors(idServ, inputData)
        setFormErrors(formErrors)

        if (!form.checkValidity() | !dropdownsAreValid() | formErrors.length !== 0)
        {
            event.stopPropagation()
            setValidated(false)
            const message = WarningIncompleteInputMessage()
            showAlert(message.variant, message.header, message.body)
            window.scrollTo(0, 0)
            return
        }

        setValidated(true)
        setLoading(true)
        prepareTaxInputV1(idServ, inputData)
        const inputBody = MapInputsToTaxBody(idServ, inputData)
        try
        {
            const taxResults = await CalcTax(idServ, inputBody, "")
            if(taxResults.error){
                const message = ErrorChamadaApi("calcular taxa", taxResults.error)
                showAlert(message.variant, message.header, message.body)
                window.scrollTo(0, 0)
            }
            else
                setResults(taxResults)
            // setInputData(inputData)
        }
        catch (error)
        {
            const message = ErrorChamadaApi("calcular taxa", error.message)
            showAlert(message.variant, message.header, message.body)
            window.scrollTo(0, 0)
        }
        finally
        {
            setLoading(false)
        }
    }


    useEffect(() => {
        // clicar no botão de calcular automaticamente para taxas fixas
        const submitButton = document.querySelector("button[type=submit]")
        if (taxaFixa & submitButton !== null)
        {
            submitButton.click()
            submitButton.remove()
        }
    })

    return (
        <>
            <LoadingSpinner show={isLoading} />
            {/*showValidationMessage ? <WarningIncompleteInput setShow={setShowValidationMessage} /> : <></>*/ }
            {/* showErrorMessage ? <ErrorChamadaApiMessage apiName={"calcular taxa"} setShow={setShowErrorMessage} /> : <></> */}
            <AlertMessage show={alert.show} variant={alert.variant} header={alert.header} message={alert.message} onClose={closeAlert} />

            <Form className={stdStyle.taxForm} name="formCalcTax" noValidate validated={validated} onSubmit={onFormSubmit}  >

                <InputScreen taxaDados = {taxaDados} typeEdifList = {typeEdifList}/>

                {resultsAreValid(results) ? <OutputScreen results={results} /> : <></>}

                <BotoesCalcularVoltar isLoading={isLoading} target={target} />
                <FormErrorMessage formErrors={formErrors} target={target} />

            </Form>
        </>
    )
}